import React from 'react';

const NotFound = () => {
    return (
        <div className='container text-center mt-5'>
            <p className='display-1 fw-bold'>404</p>
            <h1>Page Not Found</h1>
        </div>
    );
};

export default NotFound;